import { IRooms, IRoomsAction } from '../../../models/filters/rooms';
import { DEFAULT_FILTERS } from './default_filters';

export const ROOMS_UPDATE = 'search/ROOMS_UPDATE';

const initialState: IRooms = {
  rooms: ['1', '2'],
  isDirty: false,
};

const defaultAction: IRoomsAction = {
  type: '',
  payload: {},
};

export const roomsReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case ROOMS_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};

export const setSelectedRooms = (rooms: string[]): IRoomsAction => {
  return {
    type: ROOMS_UPDATE,
    payload: {
      rooms,
    },
  };
};

export const setDefaultRooms = (section: string): IRoomsAction => {
  return {
    type: ROOMS_UPDATE,
    payload: {
      rooms: DEFAULT_FILTERS[section].rooms_value,
    },
  };
};

export const setDirty = (isDirty: boolean): IRoomsAction => {
  return {
    type: ROOMS_UPDATE,
    payload: {
      isDirty,
    },
  };
};
